import { Component, effect, ChangeDetectorRef } from '@angular/core';
import { SubscriptionService } from './subscriptions.service';
import { LoginService } from './../login/login.service';
import jwt_decode from 'jwt-decode';
import { JwtService } from '../../shared/services/jwt/jwt.service';

@Component({
    selector: 'app-subscriptions',
    templateUrl: './subscriptions.component.html',
    styleUrl: './subscriptions.component.sass',
    standalone: false
})

export class SubscriptionsComponent {

  resp: any;
  userId: any;
  docSubResponse: any[] = [];
  diagSubResponse: any[] = [];
  userMail = '';
  subsLoading = false;
  userType = '';
  noData = false;
  noDiagData = false;
  readonly defaultVariant = 'DOCUMENT';
  selectedVariant = this.defaultVariant;
  variantList = [{ code: 'DOCUMENT', label: 'DOCUMENT_SUBSCRIPTIONS' },
                 { code: 'DIAGNOSTIC', label: 'DIAGNOSTIC_SUBSCRIPTIONS' }];
  showDocSubs = true;
  showDiagnosticSubs = false;
  docDisplayedColumns: string[] = [
    'variantOfferId',
    'variantOfferName',
    'documents',
    'durationType',
    'price',
    'purchaseDate',
    'offerEndDate',
    'invoiceNumber',
    'invoiceDate',
    'paymentStatus'
  ];
  diagDisplayedColumns: string[] = [
    'variantOfferId',
    'variantOfferName',
    'durationType',
    'price',
    'purchaseDate',
    'offerEndDate',
    'invoiceNumber',
    'invoiceDate',
    'paymentStatus'
  ];
  readonly paymentStatusClasses: Record<string, string> = {
    authorised: '!bg-[#fffaf2] !rounded-full border border-[--dsr-color-warning] !text-[--dsr-color-on-warning-container] !p-[5px]',
    captured: '!bg-[#f7fbff] !rounded-full border border-[--dsr-color-electric] !text-[--dsr-color-on-electric-container] !p-[5px]',
    settled: '!bg-[#f0f7f0] !rounded-full border border-[--dsr-color-success] !text-[--dsr-color-on-success-container] !p-[5px]',
    declined: '!bg-[#faf4f2] !rounded-full border border-[--dsr-color-error] !text-[--dsr-color-on-error-container] !p-[5px]'
  };

  constructor(private _subscriptionService: SubscriptionService, private loginService: LoginService,
              private jwtService: JwtService, private cdr: ChangeDetectorRef) {
    effect(() => {
      this.resp = this.loginService.gigyaResponse;          
      if(this.resp) {
        this.userId = this.resp.userId;
        this.userMail = this.resp.userMail;
        this.userType = this.resp.accessIdentifier;
        if(this.isVariantToggleDisabled()) {
          this.setSelectedVariant(this.defaultVariant);
        }
        this.getDocumentOfferSubscriptions();
        this.getDiagnosticOfferSubscriptions();
        this.cdr.detectChanges();
      }
    });
  }

  getDocumentOfferSubscriptions() {
    this.subsLoading = true;
    let request: any = { userMail: this.userMail, type: 'DO' };       
    let userRequest: string = this.jwtService.encode(request, "secret");
    this._subscriptionService.getSubscriptionDetails(userRequest).subscribe((response: any) => {
        this.subsLoading = false;
        this.noData = false;
        let encryptData = response;
        let subData: any = jwt_decode(encryptData);
        this.docSubResponse = [...subData.userSubscriptionDetails.subscriptionsListDto];
        this.docSubResponse.forEach((element: any) => {
          if(element.durationType.includes('DATE-RANGE-A5O') || element.accessIdentifier === 'ORGADMIN' || element.accessIdentifier === 'ORGUSER') {
            element.durationType = '-';
          }
        });
        if(this.docSubResponse.length === 0) {
          this.noData = true;
        }
        this.cdr.detectChanges();
      }, (error: any) => {
        this.subsLoading = false;
        this.noData = true;
        this.cdr.detectChanges();
      }
    );
  }

  getDiagnosticOfferSubscriptions() {
    this.subsLoading = true;
    let request: any = { userMail: this.userMail, type: 'DIAG' };       
    let userRequest: string = this.jwtService.encode(request, "secret");
    this._subscriptionService.getSubscriptionDetails(userRequest).subscribe((response: any) => {
        this.subsLoading = false;
        this.noDiagData = false;
        let encryptData = response;
        let subData: any = jwt_decode(encryptData);
        this.diagSubResponse = [...subData.userSubscriptionDetails.subscriptionsListDto];
        if(this.diagSubResponse.length === 0) {
          this.noDiagData = true;
        }
      }, (error: any) => {
        this.subsLoading = false;
        this.noDiagData = true;
        this.cdr.detectChanges();
      }
    );
  }

  convertDate(date: any) {
    let newdate = date.split(' ');
    let dateParam = newdate[0].split('-');
    let timeParam = newdate[1].split(':');
    let month = parseInt(dateParam[1]) - 1;
    const resp = new Date(parseInt(dateParam[0]), month, parseInt(dateParam[2]), parseInt(timeParam[0]), parseInt(timeParam[1]), parseInt(timeParam[2])).toLocaleString();
    return resp;
  }

  isVariantToggleDisabled() {
    return this.userType !== 'INDADMIN';
  }

  setSelectedVariant(variantCode: string) {
    this.selectedVariant = variantCode;
    if(this.selectedVariant === 'DOCUMENT') {
      this.showDocSubs = true;
      this.showDiagnosticSubs = false;
    } else {
      this.showDocSubs = false;
      this.showDiagnosticSubs = true;
    }
  }

  changeSelectedVariant(event: any) {
    if(this.isVariantToggleDisabled()) {
      this.setSelectedVariant(this.defaultVariant);
      return;
    }
    this.setSelectedVariant(event.value);
  }

  getPaymentStatusClass(paymentStatus: string | null | undefined): string {
    const normalizedStatus = (paymentStatus ?? '').toLowerCase();
    return this.paymentStatusClasses[normalizedStatus] || '';
  }

  getDocumentTooltip(documentTypeList: { documentDescription: string }[] | null | undefined): string {
    return (documentTypeList ?? []).map(document => `• ${document.documentDescription}`).join('\n');
  }

}